import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { sanitizeHtml } from 'src/app/shared/utils/editor-utils';

import {
  PerformanceCategoryApiModel,
  PerformanceCategoryBaseApiModel,
  MoveApiModel,
  ExtendedPerformanceCategoryApiModel
} from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class PerformanceCategoriesService {
  public apiUrl = 'performance-categories';

  constructor(private readonly http: HttpClientService) {}

  public getList(): Observable<Array<PerformanceCategoryBaseApiModel>> {
    return this.http.get<Array<PerformanceCategoryBaseApiModel>>(`${this.apiUrl}/get-list`);
  }

  public getPCItem(id: number): Observable<PerformanceCategoryBaseApiModel> {
    return this.http.get<PerformanceCategoryBaseApiModel>(`${this.apiUrl}/${id}`);
  }

  public update(model: ExtendedPerformanceCategoryApiModel): Observable<PerformanceCategoryApiModel> {
    model.Description = sanitizeHtml(model.Description);
    return this.http.put<PerformanceCategoryApiModel>(`${this.apiUrl}/update`, model);
  }

  public add(model: ExtendedPerformanceCategoryApiModel): Observable<PerformanceCategoryApiModel> {
    model.Description = sanitizeHtml(model.Description);
    return this.http.post<PerformanceCategoryApiModel>(`${this.apiUrl}/add`, model);
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${id}`);
  }

  public move(model: MoveApiModel<number>): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/move`, model);
  }

  public getPrint(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/print`, { responseType: 'blob' });
  }
}
